<template>
<div class='main'>
     <background-vue></background-vue>
    <el-row type="flex"  justify="center" class='forgetPass'>
        <el-col :span="17" class='deatail_content'> 
            <el-row class='content_cc'>
                <el-col :span="24" class='crumbs'>
                    您的位置：<a href="#">江苏省音乐家协会</a> > 忘记密码
                </el-col>
                <el-col :span="24" class='member_out'>
                    <p class='title'>忘记密码</p>
                    <el-form  class="ruleForm" ref="formData" :rules="rules2" :model='forget'>
                        <div class='formCon '>
                            <!-- <el-form-item>
                                <i class='icon iconuser'></i> 
                                <input type="text" class='inpStyle' placeholder="你的账号">
                            </el-form-item>
                           <el-form-item>
                                <i class='icon iconidenti'></i> 
                                <input type="text" class='inpStyle' placeholder="身份证号">
                            </el-form-item> -->
                            <el-form-item class='form_cc' prop="account">
                                <div class='form_icon'>
                                   <i class='icon iconuser'></i> 
                                </div>
                                <el-input class='inpStyle' v-model='forget.account' placeholder="你的账号"></el-input>
                            </el-form-item>
                            <el-form-item class='form_cc' prop="cardCode">
                                <div class='form_icon'>
                                    <i class='icon iconidenti'></i> 
                                </div>
                                <el-input class='inpStyle' v-model='forget.cardCode' placeholder="身份证号"></el-input>
                            </el-form-item>
                        </div> 
                        <div>
                            <el-form-item>
                                <div>
                                    <button class='loginBtn' @click="submit('formData')">提交</button>
                                </div>
                                <div>
                                    <button class='loginBtn' @click="subReturn()">返回</button>
                                </div>
                            </el-form-item>
                        </div>  
                        <!-- <div class='loginDea'>
                            <a @click='()=>{this.$router.push({name:"ForgetPassword"})}' class='cor' style="vertical-align:middle;">提供邮箱及手机号也可以找回密码&nbsp;
                                <i class='icon iconarrow'></i>
                            </a>
                        </div> -->
                    </el-form> 
                </el-col>
            </el-row>
        </el-col>
    </el-row>
    <div class="box_footer">
      <p style="padding:10px 0;">省音协考级报名咨询电话 025-83572077</p>
      <p>苏ICP备：10064548号</p>
    </div>
</div>
</template>
<script>
import backgroundVue from '@/components/Background.vue';
export default {
   components: {
     backgroundVue
  },
  data() {
    return{
        forget:{
            account:'',
            cardCode:'',
        },
        rules2: {
          account: [
            { required: true, message: '账号不能为空', trigger: 'blur' },
          ],
          cardCode: [
            { required: true, message: '身份证号不能为空', trigger: 'blur' },
          ],
        }
    }
  },
    methods:{
    submit(formData) {
        this.$refs[formData].validate((valid) => {
            if (valid) {
                    let self = this;
                    let data = {
                        account: this.forget.account,
                        cardCode:this.forget.cardCode
                    }
                    window.Global.post('/user/resetPswd',data,rs => {
                        if(rs.data.success){
                           alert(rs.data.message) 
                            self.$router.push({name: 'message'})
                        }else{
                            alert(rs.data.message);
                        }
                    })
                } else {
                    return false;
                }
        })
    },
    subReturn(){
        this.$router.push({name:"message"})
    }
  }
}
  
</script>
<style lang="less">
@import '../../static/less/forgetPassword.less';
</style>


// WEBPACK FOOTER //
// src/views/userForget.vue